module.exports = __webpack_public_path__ + "media/images/categories/carousel/education-92811bc6255d855ffd1d2e1eaa833813.jpg";